<template>
  <span v-if="parts.alert" class="news-alert"><img :src="alertIcon" alt="" class="news-alert-icon" />{{ parts.alert }}</span>{{ parts.rest }}
</template>

<script>
/**
 * 最新消息標題。標題以 ❗／‼／⚠ 開頭時，把第一個「｜」之前的文字
 * （例：「❗ 詐騙警示｜請勿點擊…」的「❗ 詐騙警示」）套上 .news-alert（紅字閃爍，樣式在 global.css），
 * 開頭的符號換成紅色警示三角形圖示；沒有「｜」就整個標題都算警示。
 * 其他標題原樣輸出，一般消息不受影響。資料庫標題保留符號，後台與 alt 文字照常可讀。
 *
 * 只拆字串、用 {{ }} 輸出，不走 v-html。
 */
const ALERT_TITLE = /^([❗‼⚠][^｜|]*)([\s\S]*)$/;
const ALERT_MARK = /^[❗‼⚠]️?\s*/;

export default {
  name: 'NewsTitle',
  props: {
    title: { type: String, default: '' }
  },
  data() {
    return {
      alertIcon: require('@/assets/news-alert-icon.png')
    };
  },
  computed: {
    parts() {
      const m = String(this.title || '').match(ALERT_TITLE);
      return m ? { alert: m[1].replace(ALERT_MARK, ''), rest: m[2] } : { alert: '', rest: this.title || '' };
    }
  }
};
</script>

<style scoped>
.news-alert-icon {
  height: 1.1em;
  width: auto;
  vertical-align: -0.2em;
  margin-right: 0.25em;
}
</style>
